import React, { Component } from 'react';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import './Modal.css';
import Close from '../Icons/Close.svg';
import Loader from '../Icons/Loader';

class ModalInviteBackers extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
	    	value:[],
	    	payloadFiltered: []
	    };
	    this.handleSelectChange = this.handleSelectChange.bind(this);
	    this.handleSubmit = this.handleSubmit.bind(this);
	    this.hideModal = this.hideModal.bind(this);
	}

	hideModal() {
		this.props.actions.hideModal();
	}

	handleSelectChange (value) {
		this.setState({ value: value });
	}

	componentDidMount(){
		this.getUsersListFiltered();
	}

	handleSubmit(event) {
		event.preventDefault();
		if(this.state.value.length > 0){
			this.props.actions.inviteBackers(this.state.value, this.props.dataID);
			this.props.actions.inviteBackersByEmail(this.props.data, this.state.value);
			this.props.backFormValid();
			if(this.state.value.length === 1){
				this.props.messageInfoSolo();
			}else{
				this.props.messageInfo();
			}
		}
	}

	getUsersListFiltered(){
		let payload = this.props.backers;
		payload = payload.concat(this.props.allowedusers_awaiting);
		payload = payload.concat(this.props.allowedusers_accepted);
		this.props.actions.filterUsersList(payload);
	}

	render() {
		return (
			<div>
			<div className="modalBackground" onClick={() => this.hideModal()} ></div>
				<div className="modalContainer inviteBackers">
					<div className="modalBloc">
						<div className="close" onClick={() => this.hideModal()} ><img src={Close} alt="Close" /></div>
						<div className="content">
							<div className="title">Who would you like to invite?</div>
							<form onSubmit={this.handleSubmit}>
								<div className="input">
									{this.props.usersList &&
										<Select
											closeOnSelect={false}
											disabled={false}
											multi
											onChange={this.handleSelectChange}
											options={this.props.usersListFiltered}
											placeholder="Pick-up your colleagues!"
						          			removeSelected={true}
											rtl={false}
											simpleValue
											value={this.state.value} />
									}
								</div>
								<div className="actions">
									<div className="button is-abort" onClick={() => this.hideModal()} >Cancel</div>
									<button className="button is-primary"disabled={this.props.inviteBackersIsLoading}>{this.props.inviteBackersIsLoading ? <Loader color="#fff" /> : 'Send a request'}</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default ModalInviteBackers;



// WEBPACK FOOTER //
// ./src/components/Modal/ModalInviteBackers.js